export default "__VITE_ASSET__aea73dad__"